import { useState } from "react"
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
} from "@mui/material"
import { useMutation, useQueryClient } from "@tanstack/react-query"
import { toast } from "sonner"
import { useParams } from "react-router-dom"
import { apiFetch } from "@/hooks/apiFetch"

export function DiscountImport() {
  const [openImportDialog, setOpenImportDialog] = useState(false)
  const [file, setFile] = useState(null)
  const { id } = useParams()
  const queryClient = useQueryClient()

  const importMutation = useMutation({
    mutationFn: async (file) => {
      const formData = new FormData()
      formData.append("file", file)

      return apiFetch(`discount/${id}/import-products`, {
        method: "POST",
        body: formData,
      })
    },
    onSuccess: () => {
      toast.success("Products imported successfully")
      setOpenImportDialog(false)
      setFile(null)

      queryClient.invalidateQueries({
        queryKey: ["discount", id],
      })
    },
    onError: (error) => {
      toast.error(error?.message || "Failed to import products")
    },
  })

  const importProducts = () => {
    setOpenImportDialog(true)
  }

  const handleSubmit = () => {
    if (!file) {
      toast.error("Please select an Excel file")
      return
    }

    importMutation.mutate(file)
  }

  return (
    <div className="mb-10">
      <div className="flex justify-between">
        <div className="mb-4">
          <h3>File Format</h3>
          <div>Your Excel file should contain the following columns:</div>
        </div>
        <div>
          <Button variant="contained" onClick={importProducts}>
            Import
          </Button>
        </div>
      </div>
      <table style={{ width: "100%", borderCollapse: "collapse" }}>
        <thead>
          <tr className="table-header-surface">
            <th
              style={{
                padding: "12px",
                textAlign: "left",
                border: "1px solid #ddd",
              }}
            >
              Column Name
            </th>
            <th
              style={{
                padding: "12px",
                textAlign: "left",
                border: "1px solid #ddd",
              }}
            >
              Required
            </th>
            <th
              style={{
                padding: "12px",
                textAlign: "left",
                border: "1px solid #ddd",
              }}
            >
              Desctiption
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td style={{ padding: "12px", border: "1px solid #ddd" }}>SKU</td>
            <td style={{ padding: "12px", border: "1px solid #ddd" }}>Yes</td>
            <td style={{ padding: "12px", border: "1px solid #ddd" }}>
              SKU of product
            </td>
          </tr>
        </tbody>
      </table>

      <Dialog
        open={openImportDialog}
        onClose={() => setOpenImportDialog(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Import Products</DialogTitle>

        <DialogContent>
          <Typography sx={{ mb: 2 }}>
            Select an Excel file containing SKU and Final Price columns.
          </Typography>

          <input
            type="file"
            accept=".xlsx,.xls"
            onChange={(e) => {
              const selectedFile = e.target.files?.[0]

              if (selectedFile) {
                setFile(selectedFile)
              }
            }}
          />

          {file && (
            <Typography sx={{ mt: 2 }}>Selected: {file.name}</Typography>
          )}
        </DialogContent>

        <DialogActions>
          <Button
            onClick={() => {
              setOpenImportDialog(false)
              setFile(null)
            }}
          >
            Cancel
          </Button>

          <Button
            variant="contained"
            onClick={handleSubmit}
            disabled={importMutation.isPending}
          >
            {importMutation.isPending ? "Uploading..." : "Upload"}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  )
}
